import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=4da1fc6a&scoped=true&"
import script from "./QRcode.vue?vue&type=script&lang=js&"
export * from "./QRcode.vue?vue&type=script&lang=js&"
import style0 from "./QRcode.vue?vue&type=style&index=0&id=4da1fc6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1fc6a",
  null
  
)

export default component.exports